import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider, MutationCache } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Après CHAQUE modification réussie (création/édition de résa, encaissement, chambre staff,
// annulation, no-show, groupe…), on invalide toutes les requêtes : tous les indicateurs (Finances,
// Dashboard, Groupes, Staff…) se rafraîchissent automatiquement, sans avoir à recharger la page.
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
  mutationCache: new MutationCache({
    onSuccess: () => queryClient.invalidateQueries(),
  }),
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
